import React from "react";
import { useTranslation } from "react-i18next";
import { PageHero } from "../components/PageHero";
import { FeatureList, CTASection } from "../components/Sections";
import { IMAGES } from "../data/config";

export default function Connectivity() {
  const { t } = useTranslation();
  return (
    <>
      <PageHero
        overline={t("connectivity.overline")}
        title={<>{t("connectivity.titleA")} <span className="text-signal">{t("connectivity.titleAccent")}</span></>}
        subtitle={t("connectivity.subtitle")}
        image={IMAGES.connectivity}
        accent="signal"
        testId="connectivity-hero"
      />
      <FeatureList overline={t("connectivity.featOverline")} title={t("connectivity.featTitle")} accent="signal" columns={3} items={t("connectivity.features", { returnObjects: true })} />
      <CTASection title={t("connectivity.ctaTitle")} subtitle={t("connectivity.ctaSub")} ctaLabel={t("connectivity.ctaLabel")} ctaTo="/quote?plan=nomad" testId="connectivity-cta" />
    </>
  );
}
